// import React from "react";
// import Slider from "react-slick";
// import { parsal_img } from "../../../assets/mediaCall";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const Testimonials = () => {
//   const testimonialsData = [
//     {
//       name: "David Joy",
//       location: "Lucknow",
//       rating: 4.5,
//       image: parsal_img.test1,
//       review:
//         "Way better than naaka waalas. Have shifted all my logistics needs to Parsal and I can now safely focus on my business growth. Amazing service!",
//     },
//     {
//       name: "Shreja Rao",
//       location: "Lucknow",
//       rating: 4.5,
//       image: parsal_img.test2,
//       review:
//         "Way better than naaka waalas. Have shifted all my logistics needs to Parsal and I can now safely focus on my business growth. Amazing service!",
//     },
//     {
//       name: "Richard Williams",
//       location: "Lucknow",
//       rating: 4.5,
//       image: parsal_img.test3,
//       review:
//         "Way better than naaka waalas. Have shifted all my logistics needs to Parsal and I can now safely focus on my business growth. Amazing service!",
//     },
//   ];

//   const settings = {
//     arrows: false,
//     dots: false,
//     infinite: true,
//     speed: 500,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1260,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   return (
//     <div className="bg-[#FAFAFA]">
//       <div className=" mt-2 w-[85vw] mlg:w-[90vw] smp:w-[96vw] mx-auto inter">
//         <div className="py-16 px-10 mdg:px-0 flex flex-col justify-between items-center">
//           <h2 className="text-[30px] sm:text-2xl font-extrabold mb-4">
//             Testimonials
//           </h2>
//           <div className="w-full ">
//             <Slider {...settings} className="w-full">
//               {testimonialsData.map((testimonial, index) => (
//                 <div className="px-5 sm:px-3">
//                   <div
//                     key={index}
//                     className="bg-[#FFFFFF] rounded-lg p-6  shadow-md "
//                   >
//                     {" "}
//                     {/* Adjusted mx-4 for gap */}
//                     <div className="flex items-center ">
//                       <img
//                         src={testimonial.image}
//                         alt={testimonial.name}
//                         className="rounded-full mr-4"
//                       />
//                       <div className="leading-[20px]">
//                         <h3 className="font-bold text-[18.91px] inter">
//                           {testimonial.name}
//                         </h3>
//                         <p className="text-[#777777] text-[18.91px] inter">
//                           {testimonial.location}
//                         </p>
//                         <div className="flex items-center mt-1">
//                           <span>⭐</span>
//                           <span className="ml-1">{testimonial.rating}</span>
//                         </div>
//                       </div>
//                     </div>
//                     <p className="text-[16px] text-[#000000] inter pt-4">
//                       {testimonial.review}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </Slider>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Testimonials;

import React from "react";
import Slider from "react-slick";
import { parsal_img } from "../../../assets/mediaCall";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Testimonials = () => {
  const testimonialsData = [
    {
      name: "David Joy",
      location: "Lucknow",
      rating: 4.5,
      image: parsal_img.test1,
      review:
        "Way better than naaka waalas. Have shifted all my logistics needs to Parsal and I can now safely focus on my business growth. Amazing service!",
    },
    {
      name: "Shreja Rao",
      location: "Lucknow",
      rating: 4.5,
      image: parsal_img.test2,
      review:
        "Way better than naaka waalas. Have shifted all my logistics needs to Parsal and I can now safely focus on my business growth. Amazing service!",
    },
    {
      name: "Richard Williams",
      location: "Lucknow",
      rating: 4.5,
      image: parsal_img.test3,
      review:
        "Way better than naaka waalas. Have shifted all my logistics needs to Parsal and I can now safely focus on my business growth. Amazing service!",
    },
  ];
  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="bg-[#f8f8f8]">
      <div className="  w-[85vw] mlg:w-[90vw] smp:w-[96vw] mx-auto inter">
        <div className="py-24 mdg:py-20 sm:py-16 px-10 mdg:px-0 flex flex-col justify-between items-center">
          <h2 className="text-[30px] sm:text-2xl font-extrabold mb-6 mdg:mb-4 sm:mb-2">
            Testimonials
          </h2>
          <div className="w-full ">
            <Slider {...settings} className="w-full">
              {testimonialsData.map((testimonial, index) => (
                <div className="px-5 mdg:px-3 sm:px-3 py-5">
                  <div
                    key={index}
                    className="bg-[#FFFFFF] p-8 mdg:p-6 h-[314px] sm:h-[296px] rounded-2xl"
                  >
                    {" "}
                    {/* Adjusted mx-4 for gap */}
                    <div className="flex items-center ">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="rounded-full mr-4"
                      />
                      <div className="leading-[20px]">
                        <h3 className="font-bold text-[18.91px] inter mlg:truncate mlg:max-w-[150px] smm:max-w-[120px] sm:max-w-full">
                          {testimonial.name}
                        </h3>
                        <p className="text-[#777777] text-[17.91px] inter">
                          {testimonial.location}
                        </p>
                        <div className="flex items-center mt-1">
                          <img
                            src={parsal_img.star1}
                            className="h-4 w-4 object-contain"
                          />
                          <span className="ml-1 mt-1">
                            {testimonial.rating}
                          </span>
                        </div>
                      </div>
                    </div>
                    <p className="text-[16px] text-[#000000] inter pt-4">
                      {testimonial.review}
                    </p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Testimonials;
